import { ComponentMetadataResponse, GetComponentMetadataParams } from '@Types';
import { createAction } from '@reduxjs/toolkit';

export const clearComponentMetadata = createAction(
	'Comp/clearComponentMetadata',
);
export const getLoFComponentAssetMetadata =
	createAction<GetComponentMetadataParams>(
		'Comp/getLoFComponentAssetMetadata',
	);
export const getLoFComponentInspectionMetadata =
	createAction<GetComponentMetadataParams>(
		'Comp/getLoFComponentInpsectionMetadata',
	);
export const getCoFComponentAssetMetadata =
	createAction<GetComponentMetadataParams>(
		'Comp/getCoFComponentAssetMetadata',
	);
export const getLoFComponentProximityMetadata =
	createAction<GetComponentMetadataParams>(
		'Comp/getLoFComponentProximityMetadata',
	);
export const getCoFComponentProximityMetadata =
	createAction<GetComponentMetadataParams>(
		'Comp/getCoFComponentProximityMetadata',
	);
export const getLoFComponentProximityAttrMetadata =
	createAction<GetComponentMetadataParams>(
		'Comp/getLoFComponentProximityAttrMetadata',
	);
export const getCoFComponentProximityAttrMetadata =
	createAction<GetComponentMetadataParams>(
		'Comp/getCoFComponentProximityAttrMetadata',
	);
export const getLoFComponentCustomTableMetadata =
	createAction<GetComponentMetadataParams>(
		'Comp/getLoFComponentCustomTableMetadata',
	);
export const getCoFComponentCustomTableMetadata =
	createAction<GetComponentMetadataParams>(
		'Comp/getCoFComponentCustomTableMetadata',
	);
export const getLoFComponentTaskMetadata =
	createAction<GetComponentMetadataParams>(
		'Comp/getLoFComponentTaskMetadata',
	);
export const getCoFComponentTaskMetadata =
	createAction<GetComponentMetadataParams>(
		'Comp/getCoFComponentTaskMetadata',
	);
export const getLoFComponentFailureDefinitionMetadata =
	createAction<GetComponentMetadataParams>(
		'Comp/getLoFComponentFailureDefinitionMetadata',
	);
export const getCoFComponentFailureDefinitionMetadata =
	createAction<GetComponentMetadataParams>(
		'Comp/getCoFComponentFailureDefinitionMetadata',
	);
export const getLoFComponentDeteriorationModelMetadata =
	createAction<GetComponentMetadataParams>(
		'Comp/getLoFComponentDeteriorationModelMetadata',
	);
export const getCoFComponentDeteriorationModelMetadata =
	createAction<GetComponentMetadataParams>(
		'Comp/getCoFComponentDeteriorationModelMetadata',
	);

export const getComponentMetadataResolved =
	createAction<ComponentMetadataResponse>(
		'Comp/getComponentMetadataResolved',
	);
export const getComponentMetadataRejected = createAction(
	'Comp/getComponentMetadataRejected',
);
